angular.module('controllers').controller('clientSettingController', ['$scope', '$rootScope', '$controller', '$http', 'Crud', '$mdDialog',
    function ($scope, $rootScope, $controller, $http, Crud, $mdDialog) {
        $rootScope.path = '/client-setting';
        $rootScope.modelName = 'client-setting';
        $scope.path = $rootScope.path;
        $scope.pathTemplate = 'clients/clientsettings';
        $scope.title = 'Setari client';

        angular.extend(this, $controller('crudController', {$scope: $scope}));

        $rootScope.sortType = 'id';
        $rootScope.typeId = 'id';
        $scope.additionals = [];
        $scope.additionals['content_type'] = 'form-urlencoded';
        $scope.message = '';
        $scope.classAction = 'td-big';

        $scope.additionals['searchTerm'];
        $scope.additionals['clearSearchTerm'] = function() {
            $scope.additionals['searchTerm'] = '';
        };
        $scope.additionals['onSearchChange'] = function(ev) {
            ev.stopPropagation();
        };

        $scope.additionals['report_client_types'] = [
            {'id':0, 'value' : ''},
            {'id':1, 'value' : 'Client fidel'},
            {'id':2, 'value' : 'Client unic'},
            {'id':3, 'value' : 'Client inactiv'},
            {'id':4, 'value' : 'Client cu incidente'}
        ];
        $scope.additionals['report_client_type'] = {};
        $scope.additionals['report_client_type'].options = $scope.additionals['report_client_types'];

        $scope.getClientSettings = function () {
            $scope.additionals['invalid'] = '';
            Crud.get($scope.path+'/index')
                .success(function (data) {
                    if (!angular.isUndefined(data)) {

                      if (angular.isUndefined($scope.modelData)) {
                        $scope.modelData = {};
                      }
                      if (angular.isUndefined($scope.modelData.client_settings)) {
                        $scope.modelData.client_settings = {};
                      }
                      $scope.modelData.client_settings = data;

                    }
                });
        }

        /* save a model */
        $scope.success = false;
        $scope.updateModel = function () {
            $scope.additionals['buttonDisabled'] = true;
            $scope.isLoading = true;
            $scope.additionals['invalid'] = '';
            $scope.modelData['route'] = 'store';

            Crud.save($scope.additionals['content_type'], $scope.modelData, $scope.path)
                .success(function (data) {
                    if (!angular.isUndefined(data.invalid)) {
                        $scope.additionals['invalid'] = data.invalid;
                    } else {
                        if (!angular.isUndefined(data.model)) {
                            if (angular.isUndefined($scope.modelData)) {
                              $scope.modelData = {};
                            }
                            if (angular.isUndefined($scope.modelData.client_settings)) {
                              $scope.modelData.client_settings = {};
                            }
                            $scope.modelData.client_settings = data.model;

                        }
                    }
                    $scope.isLoading = false;
                    $scope.errors = {};
                    $scope.success = true;
                    $scope.additionals['buttonDisabled'] = false;

                })
                .error(function (data) {
                    $scope.isLoading = false;
                    $scope.success = false;
                    $scope.errors = data.errors;
                    $scope.additionals['buttonDisabled'] = false;
                });
        };


    }]
)
